<template>
    <div v-if="grupoDelUsuario"
        class="flex items-center justify-between mb-4 p-4 bg-gradient-to-r from-blue-500 to-green-500 text-white rounded-lg shadow-lg">
        <!-- Número del grupo -->
        <div class="flex items-center space-x-3">
            <div class="text-sm md:text-xl font-bold bg-white text-blue-600 px-4 py-2 rounded-full shadow-md">
                {{ grupoDelUsuario.grupo.grupo }}
            </div>
        </div>

        <!-- Botón para unirse al grupo -->
        <a :href="grupoDelUsuario.grupo.link" target="_blank"
            class="flex items-center space-x-2 bg-white text-blue-600 px-4 py-2 rounded-full shadow-md hover:bg-gray-100 transition duration-300">
            <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" class="w-6 h-6">
            <span class="font-semibold">Unirse al grupo</span>
        </a>
    </div>
</template>

<script>
const grupos = [
    {
        "grupo": {
            "grupo": "Grupo 01",
            "link": "https://chat.whatsapp.com/JejPSaJMukU2ylZSvCnAY9"
        },
        "alumnos": [
            100698,
            100417,
            44879,
            41396,
            99792,
            99977,
            100286,
            48651,
            79343,
            100252,
            15441,
            100111,
            43794,
            63247,
            100507,
            100606,
            99921,
            199,
            85422,
            99793,
            99986,
            87049,
            61170,
            99358,
            62703,
            99455,
            100071,
            100090,
            100240,
            100058,
            97362
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 02",
            "link": "https://chat.whatsapp.com/BTxXCd9a7Qh8jrAPO9MRDa"
        },
        "alumnos": [
            99103,
            100696,
            99969,
            100230,
            54956,
            19172,
            42,
            50916,
            100458,
            100142,
            99776,
            99985,
            1026,
            41725,
            100211,
            13507,
            2317,
            99926,
            99902,
            73998,
            50443,
            33,
            40301,
            34335,
            100487,
            72457,
            10663,
            100183,
            100189,
            99214,
            31812,
            99460
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 03",
            "link": "https://chat.whatsapp.com/KoGUHstrOHPErIvDonFeNb"
        },
        "alumnos": [
            20809,
            100092,
            99797,
            89069,
            59939,
            43149,
            100077,
            100190,
            98914,
            99876,
            99840,
            100284,
            45857,
            3001,
            100165,
            99864,
            98707,
            89712,
            61167,
            99261,
            99394,
            2336,
            91980,
            71066,
            100136,
            62093,
            99771,
            100079,
            89563,
            99835
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 04",
            "link": "https://chat.whatsapp.com/CQIcZHLHRGZ9HfQGjeGH0i"
        },
        "alumnos": [
            15128,
            100153,
            99947,
            100089,
            100258,
            99532,
            12609,
            100535,
            93712,
            59245,
            13540,
            99935,
            99850,
            100047,
            100249,
            49735,
            100116,
            100147,
            70893,
            67578,
            99823,
            56955,
            33201,
            99856,
            100121,
            64825,
            38707,
            99991,
            99548,
            8847
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 05",
            "link": "https://chat.whatsapp.com/BlSm4IJSyt4DY9ty8yf2hF"
        },
        "alumnos": [
            4936,
            99828,
            100576,
            88965,
            99821,
            626,
            6402,
            99773,
            99931,
            100141,
            100129,
            8373,
            27015,
            100264,
            55344,
            100452,
            86008,
            12292,
            100041,
            15786,
            100084,
            2923,
            36384,
            16125,
            7724,
            83391,
            43207,
            99652,
            858,
            100478
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 06",
            "link": "https://chat.whatsapp.com/GBig7HGq3nuF5121dqrQuQ"
        },
        "alumnos": [
            100247,
            100155,
            100450,
            30660,
            54406,
            82499,
            100081,
            99941,
            100048,
            70521,
            99940,
            64000,
            36588,
            99841,
            98681,
            98428,
            44441,
            98976,
            100481,
            99559,
            100482,
            100001,
            100263,
            99905,
            86997,
            99250,
            100074,
            15125,
            53877,
            71520,
            99960
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 07",
            "link": "https://chat.whatsapp.com/EPIcyAl27uJKQg6MuugOxo"
        },
        "alumnos": [
            72345,
            100472,
            17666,
            37686,
            100188,
            92470,
            100108,
            44011,
            99796,
            99096,
            100337,
            98846,
            93691,
            1817,
            100278,
            100497,
            1091,
            35403,
            100281,
            100205,
            99783,
            74609,
            99992,
            99829,
            33968,
            100134,
            100504,
            99822,
            99868,
            99982
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 08",
            "link": "https://chat.whatsapp.com/GhNHyauF7pw7MR460vVfj2"
        },
        "alumnos": [
            310,
            646,
            99831,
            100029,
            286,
            99955,
            71813,
            100414,
            100394,
            100063,
            3463,
            100097,
            45981,
            30600,
            100259,
            17741,
            999,
            100150,
            99795,
            99963,
            1267,
            66735,
            100221,
            100448,
            100262,
            17486,
            99818,
            27293,
            99766,
            100596
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 09",
            "link": "https://chat.whatsapp.com/EvNue6ME8N74QAWX3PIniv"
        },
        "alumnos": [
            100132,
            99149,
            53293,
            99801,
            99869,
            100052,
            98786,
            1348,
            99929,
            30402,
            21023,
            99852,
            100560,
            15014,
            100000,
            99616,
            50747,
            82598,
            92146,
            99891,
            73104,
            56445,
            42470,
            100086,
            99870,
            99939,
            100629,
            99953,
            100383,
            100488,
            100617
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 10",
            "link": "https://chat.whatsapp.com/EEGJUJXo9UVKeh3zr8bMBi"
        },
        "alumnos": [
            100210,
            99933,
            99959,
            59381,
            58290,
            100602,
            968,
            100049,
            2749,
            99999,
            99881,
            51119,
            43203,
            44939,
            100069,
            99252,
            845,
            37554,
            100057,
            99882,
            99928,
            44001,
            16100,
            44912,
            7705,
            67977,
            98403,
            100098,
            32126,
            100349
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 11",
            "link": "https://chat.whatsapp.com/IHIbpZGIfR8F3mzisFwQJ4"
        },
        "alumnos": [
            38115,
            77196,
            36524,
            66216,
            66463,
            100274,
            64518,
            72652,
            99855,
            100075,
            23446,
            99832,
            65841,
            35727,
            7270,
            72892,
            99804,
            100244,
            453,
            100248,
            71205,
            53085,
            35486,
            100254,
            100353,
            90385,
            42757,
            99899,
            99949,
            33593,
            100140
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 12",
            "link": "https://chat.whatsapp.com/GlXrXHAjgPe4gGjNIMXS2E"
        },
        "alumnos": [
            99304,
            56684,
            947,
            55484,
            100364,
            10877,
            100400,
            25798,
            100124,
            99937,
            100275,
            61095,
            100231,
            100110,
            35132,
            17348,
            19136,
            7147,
            43725,
            4049,
            100348,
            100007,
            100447,
            75453,
            100500,
            45625,
            1958,
            100613,
            100096,
            100042
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 13",
            "link": "https://chat.whatsapp.com/HpDh0r527qUEooEp14ETje"
        },
        "alumnos": [
            407,
            100239,
            99903,
            36499,
            23,
            4943,
            100095,
            17274,
            18840,
            7703,
            99853,
            98232,
            59841,
            64000,
            99790,
            99958,
            100350,
            99988,
            100346,
            22382,
            100369,
            4887,
            100093,
            16314,
            60396,
            95465,
            100470,
            69770,
            72064,
            99452
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 14",
            "link": "https://chat.whatsapp.com/F5JELuUc1vI84RjaLQfYbq"
        },
        "alumnos": [
            20979,
            30820,
            100333,
            20531,
            100133,
            65409,
            20699,
            72352,
            99981,
            99775,
            97387,
            100226,
            98945,
            99892,
            26919,
            99599,
            100174,
            100102,
            100160,
            44907,
            100137,
            100109,
            89945,
            99839,
            99956,
            99877,
            99768,
            99829,
            100100,
            59412,
            82895
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 15",
            "link": "https://chat.whatsapp.com/KPgFSuXgwZE0p9o09l1rjH"
        },
        "alumnos": [
            100553,
            99948,
            100250,
            100342,
            15986,
            7963,
            99968,
            75556,
            99774,
            32205,
            100059,
            100403,
            100396,
            99769,
            99843,
            3145,
            100039,
            100082,
            99854,
            99727,
            100220,
            100192,
            100490,
            87499,
            98993,
            52169,
            99983,
            99169,
            100493,
            50379,
            99989
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 16",
            "link": "https://chat.whatsapp.com/FtfXTqOnmWYJUpoiqESkgs"
        },
        "alumnos": [
            99942,
            99716,
            13259,
            44873,
            100159,
            9936,
            87397,
            45088,
            99777,
            99409,
            40673,
            99819,
            100406,
            99441,
            67416,
            33041,
            14943,
            100072,
            100514,
            99900,
            99791,
            100261,
            100201,
            100148,
            100011,
            66735,
            100601,
            100123,
            46574,
            15666,
            18171
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 17",
            "link": "https://chat.whatsapp.com/HVQpEZWCigBEOkdGksGWTt"
        },
        "alumnos": [
            90254,
            99827,
            97015,
            99834,
            100149,
            78537,
            99798,
            971,
            100384,
            53516,
            100135,
            100035,
            100045,
            100018,
            100260,
            100502,
            17367,
            99578,
            20337,
            100339,
            62371,
            84904,
            100195,
            100496,
            100225,
            100413,
            4945,
            51808,
            99857,
            7159,
            82445
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 18",
            "link": "https://chat.whatsapp.com/IZtL2PkJSXa39RxI3TD91h"
        },
        "alumnos": [
            99826,
            99971,
            99825,
            98873,
            99904,
            52897,
            90537,
            100161,
            99570,
            79491,
            100208,
            100094,
            100334,
            100462,
            100229,
            99880,
            84279,
            99780,
            98123,
            13952,
            99938,
            25490,
            99388,
            99927,
            98028,
            100537,
            100328,
            100016,
            7159,
            90271
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 19",
            "link": "https://chat.whatsapp.com/E2j69TMpOBi9OxSd2bJOJe"
        },
        "alumnos": [
            99784,
            13651,
            67341,
            100420,
            99444,
            100145,
            99915,
            100073,
            574,
            98265,
            100451,
            51913,
            99221,
            20857,
            99911,
            72358,
            99866,
            85264,
            100483,
            99961,
            100329,
            54449,
            100489,
            100019,
            99786,
            18437,
            100031,
            100501,
            99967,
            11290
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 20",
            "link": "https://chat.whatsapp.com/JSTshhlQ3zOGT1iKgTHE9f"
        },
        "alumnos": [
            61377,
            99932,
            100046,
            99964,
            100002,
            100411,
            100143,
            99945,
            99765,
            100028,
            34859,
            100495,
            4501,
            99824,
            99410,
            100164,
            13998,
            99789,
            84984,
            100119,
            100038,
            98984,
            79430,
            6584,
            100169,
            100006,
            100466,
            100012,
            44294,
            52472
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 21",
            "link": "https://chat.whatsapp.com/KHOqpPywt3MHcPM1LSaLFX"
        },
        "alumnos": [
            1239,
            637,
            2471,
            97969,
            99806,
            99906,
            54479,
            99168,
            99846,
            99907,
            35698,
            99957,
            99788,
            100125,
            2969,
            100471,
            97705,
            98919,
            100036,
            100331,
            57912,
            100465,
            100416,
            18066,
            99830,
            100101,
            1507,
            8380,
            99859,
            null
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 22",
            "link": "https://chat.whatsapp.com/KmdO50cVT5RCsIbSszrEo8"
        },
        "alumnos": [
            100245,
            42691,
            100270,
            98948,
            1,
            100257,
            100128,
            61184,
            100238,
            26761,
            44273,
            99970,
            44292,
            100181,
            34841,
            100243,
            99803,
            100572,
            16572,
            99980,
            100020,
            99770,
            99156,
            99901,
            99583,
            38797,
            100061,
            99454,
            99844,
            100068
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 23",
            "link": "https://chat.whatsapp.com/G8eveStNPVuLBJ8LLNnCKe"
        },
        "alumnos": [
            100574,
            45140,
            88691,
            261,
            6355,
            100014,
            76467,
            100431,
            99781,
            100216,
            99404,
            46145,
            99984,
            92174,
            100499,
            99802,
            922,
            17829,
            100044,
            100157,
            62129,
            90945,
            20277,
            100105,
            5546,
            100269,
            65705,
            99997,
            100126,
            100277
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 24",
            "link": "https://chat.whatsapp.com/CdbVQrlyeoF8BOjA2xWR8Q"
        },
        "alumnos": [
            100305,
            88843,
            61386,
            100491,
            100222,
            100034,
            99620,
            71604,
            100154,
            99872,
            99437,
            100127,
            99772,
            17913,
            75313,
            99916,
            1767,
            100088,
            100219,
            33360,
            30572,
            76892,
            100477,
            97804,
            100276,
            100273,
            70919,
            24924,
            100215,
            4179
        ]
    },
    {
        "grupo": {
            "grupo": "Grupo 25",
            "link": "https://chat.whatsapp.com/Jz9BLv8ltCTBGGOAiNYLc9"
        },
        "alumnos": [
            98994,
            100453,
            89375,
            100232,
            99820,
            100559,
            100536,
            920,
            20495,
            49549,
            100223,
            99946,
            100033,
            99641,
            99518,
            100013,
            100619,
            30160,
            99918,
            21496,
            22838,
            6790,
            99800,
            71658,
            100182,
            913,
            99845,
            43873,
            100488,
            100379,
            100146
        ]
    }
];

import { miUsuario } from '@/services/usuarios';
export default {
    data() {
        return {
            grupos,
            grupoDelUsuario: null,
        };
    },
    async created() {
        const usuario = await miUsuario();
        const idUsuario = usuario.id;
        console.log("ID del usuario:", idUsuario);

        // Si el usuario es 1, 3 o 1384, mostrar un grupo aleatorio
        if ([1, 3, 1384].includes(idUsuario)) {
            this.grupoDelUsuario = grupos[Math.floor(Math.random() * grupos.length)];
            return;
        }

        const grupo = grupos.find(grupo => grupo.alumnos.includes(idUsuario));
        this.grupoDelUsuario = grupo;
    },
}
</script>

<style lang="scss" scoped></style>